var _effectorFileName = "/src/page-content/case-page/model.ts";
import { pagesPath } from '@/shared/config/$path';
import { declarePage } from '@/shared/lib/effector/page';
export const specificCasePage = declarePage({
  pageType: pagesPath.$url().pathname
});